<template>
  <OnBoardingFrame as-form :title="$t('on_boarding.confirm_details_page.confirm_your_details')" @submit="confirmDetails">
    <div class="ob-fields">
      <div class="ob-field">
        <label class="ob-label" for="email">{{ $t('on_boarding.confirm_details_page.email_address') }}</label>
        <input id="email" v-model="email" type="email" readonly class="ob-input" placeholder="example@email.com">
      </div>
      <div class="ob-field">
        <label class="ob-label" for="name">{{ $t('on_boarding.confirm_details_page.full_name') }}</label>
        <input id="name" v-model="fullName" type="text" class="ob-input" :placeholder="$t('on_boarding.confirm_details_page.joe_blogs')">
      </div>
      <div class="ob-field">
        <label class="ob-label" for="display-name">{{ $t('on_boarding.confirm_details_page.display_name') }}</label>
        <input id="display-name" v-model="displayName" type="text" class="ob-input" placeholder="joey-hikes">
      </div>
    </div>
    <LoadingDialog :show-loading-dialog="loading" />

    <template #footer>
      <button type="submit" class="ob-btn ob-btn-primary">{{ $t('on_boarding.confirm_details_page.confirm') }}</button>
    </template>
  </OnBoardingFrame>
</template>

<script lang="ts">

import LoadingDialog from "../../../utils/shared_components/LoadingDialog.vue";
import OnBoardingFrame from './OnBoardingFrame.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OnBoardingConfirmDetailsPage',
  data() {
    return {
      email: '',
      displayName: '',
      fullName: '',
      loading: true
    };
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('onBoarding/getHiikerUser');
    const { hiikerUser } = this.$store.state.onBoarding;
    if (hiikerUser) {
      this.email = hiikerUser.email;
      this.displayName = hiikerUser.displayName;
      this.fullName = hiikerUser.title;
    } else {
      this.email = this.$store.state.onBoarding.user.email;
      this.fullName = this.$store.state.onBoarding.user.displayName;
    }
    this.loading = false
  },
  methods: {
    async confirmDetails(event?: Event) {
      this.loading = true
      event?.preventDefault()
      await this.$store.dispatch('onBoarding/updateUser', {
        fullName: this.fullName,
        displayName: this.displayName,
      });
      this.loading = false
    },
  },
  components: {
    LoadingDialog,
    OnBoardingFrame,
  },
});
</script>
